import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom'
import router from './router'
import 'antd/dist/antd.less';
import { Provider } from 'react-redux';
import store from './store';
import 'normalize.css'
import zhCN from 'antd/lib/locale/zh_CN';
// import zhCN from 'antd/lib/locale/zh_CN'
import 'moment/dist/locale/zh-cn'
import { ConfigProvider } from "antd";
import '@/iconFont/iconfont.css'
import { AliveScope,KeepAlive } from 'react-activation';

console.log(KeepAlive, 'a'); // 应该输出函数
const root = ReactDOM.createRoot(document.getElementById('root'));
console.log(AliveScope, 'k'); // 应该输出函数
root.render(
  <ConfigProvider locale={zhCN}>
    {/*<React.StrictMode>*/}
    <Provider store={store}>
      <AliveScope>
        <KeepAlive
          name="Canteen"
          saveScrollPosition // 自动保存滚动位置
          when={(current, action) => {
            // 仅当返回时保留缓存
            return action === 'POP' && current === 'back';
          }}
        >
          <RouterProvider router={router} />
        </KeepAlive>
      </AliveScope>
    </Provider>
    {/*</React.StrictMode>*/}
  </ConfigProvider>

);

